import { useRef, useState, useLayoutEffect } from "react";

// Shows an image turned clockwise by `rotation` degrees, fitted below the overlay buttons.
export default function Turned({ src, rotation }) {
  const box = useRef();
  const [w, setW] = useState(0);
  useLayoutEffect(() => {
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    ro.observe(box.current);
    return () => ro.disconnect();
  }, []);
  const side = rotation % 180 !== 0;
  const style = side
    ? { transform: `rotate(${rotation}deg)`, maxWidth: "18rem", maxHeight: w || "100%" }
    : { transform: `rotate(${rotation}deg)`, maxWidth: "100%", maxHeight: "18rem" };
  return (
    <div ref={box} className="flex h-96 w-full items-center justify-center overflow-hidden py-12">
      <img src={src} alt="Document" style={style} className="object-contain transition-transform duration-300" data-testid="photo-preview-image" />
    </div>
  );
}
